import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from 'react-router-dom';
import { usePersistedDataStore, useLocalDataStore } from '../../../store.js';
import CopyableIdCell from '../../../../common/CopyableIdCell.js';
import { renderUnifiedTooltip } from '../utils/helpers.js';

const AddressCell = ({ row, townView }) => {
  const setReviewPage = useLocalDataStore((state) => state.setReviewPage);
  const getNegotiationObj = usePersistedDataStore((state) => state.negotiationObj);
  const navigate = useNavigate();

  const getCompNumber = () => {
    if (!row.parcel_id || !getNegotiationObj?.cases) {
      return 1;
    }
    
    const actualIndex = getNegotiationObj.cases.findIndex(c => c.parcel_id === row.parcel_id);
    
    if (actualIndex === -1) {
      return 1;
    }
    
    return actualIndex + 1;
  };
  
  const handleAddressClick = () => {
    if (row.loading) return;
    const compNumber = getCompNumber();
    const params = new URLSearchParams(window.location.search);
    params.set('comp', compNumber);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    setReviewPage(false);
    navigate(newUrl);
  };
  
  const addressStyle = row.addressStyle || {};
  const color = addressStyle.color || (row.loading ? 'gray' : '#1976d2');
  
  const addressText = (
    <span
      onClick={row.loading ? undefined : handleAddressClick}
      style={{
        ...addressStyle,
        textDecoration: row.loading ? 'none' : 'underline',
        color: addressStyle.color || (row.loading ? 'gray' : color),
        fontStyle: addressStyle.fontStyle || (row.loading ? 'italic' : 'normal'),
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        flex: 1,
        minWidth: 0,
        cursor: row.loading ? 'default' : 'pointer',
      }}
    >
      {row.Address}
    </span>
  );
  
  const notBarFiled = !row.MasterPetition && !row.barFiled;

  if (row.loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <span style={{ color: !row.MasterPetition && (row.notFiledAtScar || notBarFiled) ? '#aaa' : '#888', fontStyle: 'italic', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, minWidth: 0 }}>
          {row.Address}
        </span>
        <span style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
          <CircularProgress size={16} style={{ marginLeft: 8 }} />
        </span>
      </Box>
    );
  }
  
  if (!row.MasterPetition && (notBarFiled || row.notFiledAtScar) && row.statusDisplay !== 'Negotiating') {
    let tooltipLines = [notBarFiled ? 'Case not BAR filed' : 'This case is flagged to not file SCAR'];
    
    const notFiledAddressStyle = { color: '#aaa', fontStyle: 'italic', cursor: townView ? 'default' : 'pointer' };
    
    if (townView) {
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
          <Tooltip title={renderUnifiedTooltip(tooltipLines)} placement="top" disableInteractive>
            <span style={{ ...notFiledAddressStyle, flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {row.Address}
            </span>
          </Tooltip>
          <Box sx={{ marginLeft: '4px', flexShrink: 0 }}>
            <CopyableIdCell 
              value={row.Address} 
              label="Address"
              showValue={false}
            />
          </Box>
        </Box>
      );
    }
    
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <Tooltip title={renderUnifiedTooltip(tooltipLines)} placement="top" disableInteractive>
          <span
            onClick={townView ? undefined : handleAddressClick}
            style={{ 
              ...notFiledAddressStyle, 
              flex: 1, 
              minWidth: 0, 
              overflow: 'hidden', 
              textOverflow: 'ellipsis', 
              whiteSpace: 'nowrap',
              textDecoration: townView ? 'none' : 'underline'
            }}
          >
            {row.Address}
          </span>
        </Tooltip>
        <Box sx={{ marginLeft: '4px', flexShrink: 0 }}>
          <CopyableIdCell 
            value={row.Address} 
            label="Address"
            showValue={false}
          />
        </Box>
      </Box>
    );
  }
  
  if (townView) {
    const awaitingDecisionMuted = !!row.AwaitingDecision;
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <span
          style={{
            color: awaitingDecisionMuted ? 'rgba(0, 0, 0, 0.38)' : 'black',
            fontStyle: 'normal',
            flex: 1,
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {row.Address}
        </span>
        <Box sx={{ marginLeft: '4px', flexShrink: 0 }}>
          <CopyableIdCell 
            value={row.Address} 
            label="Address"
            showValue={false}
          />
        </Box>
      </Box>
    );
  }
  
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        {addressText}
      </Box>
      <Box sx={{ marginLeft: '4px', flexShrink: 0 }}>
        <CopyableIdCell 
          value={row.Address} 
          label="Address"
          showValue={false}
        />
      </Box>
    </Box>
  );
};

export default AddressCell;
